import { useMemo } from 'react';
import { usePatientCard } from '../../../../hooks/usePatientCard';
import type { GetPatientResponse } from '../../../../services/patientCard';
import { IN_TREATMENT_STATUSES } from '../../../work-queue/constants';
import {
    plannerTriggerScope,
    type PlannedTriggerSeries,
    type PlannerPatientFacts,
    type PlannerTriggerScope
} from './plannerTriggerScope';

function factsFromCard(card: GetPatientResponse | null): PlannerPatientFacts | null {
    if (!card?.status || !card.monitoring) return null;
    const status = card.status.internalCaseStatus;
    return {
        inTreatment: status !== null && IN_TREATMENT_STATUSES.has(status),
        treatmentStartDate: card.monitoring.treatmentStartDate,
        currentAligner: card.monitoring.currentAligner,
        totalAligners: card.monitoring.totalAligners,
        dmLinked: card.monitoring.dmId != null
    };
}

// Reads the patient card the wizard's form step already loaded, so no extra request.
export function usePlannerTriggerScope(
    patientId: string,
    series: PlannedTriggerSeries
): PlannerTriggerScope | null {
    const { data: card } = usePatientCard(patientId);
    return useMemo(
        () => plannerTriggerScope({ series, facts: factsFromCard(card) }),
        [series, card]
    );
}
